import React, { useContext, useState } from "react";
import LoadingIcon from "../../images/Loading_icon.gif";
import Swal from "sweetalert2";
import { UrlContext } from "../../contexts/UrlContext";

export default function MergeExpertsBtn({ expertName }) {
  const [mergePopup, setMergePopup] = useState(false);
  const { API_URL } = useContext(UrlContext);
  const handleMerge = () => {
    setMergePopup(true);
    const url = `${API_URL}check-merge?expertName=${expertName}`;
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setMergePopup(false);
        if (data.status === "only profile") {
          Swal.fire({
            icon: "info",
            title: "No duplicates found",
            timer: 1500,
            showConfirmButton: false,
          });
        } else if (data.status === "multiple") {
          window.open(`/app/MergeExperts/${expertName}`, "_self");
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
            timer: 1500,
            showConfirmButton: false,
          });
        }
      })
      .catch((err) => {
        setMergePopup(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          timer: 1500,
          showConfirmButton: false,
        });
      });
  };

  return (
    <>
      <button className="btn mergeButton" onClick={handleMerge}>
        <i className="fa-regular fa-object-group" /> Merge
      </button>

      {mergePopup && (
        <div className="linkedin-popup-wrapper">
          <div className="tab-pane fade show linkedin-div">
            <center>
              <p style={{ fontSize: "18px" }}>Searching profiles...</p>
              <br />
              <img
                src={LoadingIcon}
                alt=""
                style={{ width: "50px", marginRight: "5px" }}
              />
            </center>
          </div>
        </div>
      )}
    </>
  );
}
